import {NDVSClient} from "../../client/NDVSClient";
import {getCurrentTime, getStartTime} from "../../util/NetworkUtil";

export function fetchExceptionShipments(dispatcher) {
    NDVSClient.getExceptionShipments({
        categories: ["WRONG_PLANNED_STATION", "WRONG_STATION_SAME_CITY"],
        targetStatus: "RESOLVED",
        startDate: Math.floor(getStartTime().getTime()/1000),
        endDate: Math.floor(getCurrentTime().getTime()/1000),
        shipmentDetailsRequired: true
    }).then(({valid, data}) => {
        if (valid) {
            const packageList = data.transferShipments
                .map(({
                          scannableId, exceptionState,
                          category, operationPerson
                      }) => ({
                    TRACKING_ID: scannableId || "",
                    EXCEPTION_STATE: exceptionState || "",
                    CATEGORY: category || "",
                    OPERATION_PERSON: operationPerson || ""
                }));
            dispatcher({
                type: "SET_DATA",
                data: packageList
            })
        } else {
            dispatcher({
                type: "SET_ERROR"
            })
        }
    });
}


// WEBPACK FOOTER //
// ./src/components/transferSheet/network/PackageListAPI.js